import { get, merge } from 'lodash'

/**
 * @param {Object<string, any>} obj
 * @param {string} label
 * @param {string} field
 * @param {Object<string, any>} [overwrite]
 */
export function textLabel(obj, label, field, overwrite = {}) {
  const defaultOptions = {
    label: label + ':',
    value: get(obj, field),
    editable: {
      field,
      title: `Update ${label.toLowerCase()}`,
      type: 'text',
      value: get(obj, field)
    }
  }

  return merge(defaultOptions, overwrite)
}

/**
 * @param {Object<string, any>} obj
 * @param {string} label
 * @param {string} value
 * @param {string} editableField
 * @param {string} editableValue
 * @param {Array} options
 * @param {Object<string, any>} [overwrite]
 */
export function selectLabel(obj, label, value, editableField, editableValue, options, overwrite = {}) {
  const defaultOptions = {
    label: label + ':',
    value: get(obj, value),
    editable: {
      field: editableField,
      title: `Update ${label.toLowerCase()}`,
      type: 'select',
      value: get(obj, editableValue, 0),
      options: [{ id: 0, name: 'None' }, ...options]
    }
  }

  return merge(defaultOptions, overwrite)
}
